import React, { Fragment } from 'react'
import './chairman.css'
import { Link } from 'react-router-dom'
const ChairMan = () => {
    return (
        <Fragment>
            <div className='chairman-director-container'>
                <div className='chairman-director-row'>
                    <div className='chairman column'>
                        <div className='chairman-image-container'>
                            <img src="images/chairman-image.jpg" alt="Shri. S. Manjit Singh Bhatti" className='chairman-image' />
                            <div className='chairma-content'>
                                <h1 className="chairman-name">Shri. S. Manjit Singh Bhatti</h1>
                                <p className='person-post'>Hon. Chairman</p>
                                <Link to="/chairman-message" className='read-message-link'><button className='read-message'>Chairman's Message</button></Link>
                            </div>
                        </div>
                    </div>
                    <div className='director column'>
                        <div className='director-image-container'>
                            <img src="images/ritu-director.jpg" alt="Dr. Ritu Bhattacharyya" className='chairman-image' />
                            <div className='chairma-content'>
                            <h1 className="chairman-name">Dr. Ritu Bhattacharyya</h1>
                            <p className='person-post'>Director</p>
                            <Link to="/director-message" className='read-message-link'><button className='read-message'>Director's Message</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ChairMan